// InternetSpeed.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,   FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
import { Button } from "@mui/material";
const TITLE = "Cara Mengukur Kecepatan Internet dengan Akurat dan Mudah";
const DESCRIPTION =
  "Temukan cara mengukur kecepatan internet dengan akurat dan mudah menggunakan alat pengukur kecepatan internet. Ukur kecepatan unduh dan unggah Anda dan pastikan Anda mendapatkan kinerja optimal.";
const KEYWORDS =
  "ukur kecepatan internet, kecepatan internet, tes kecepatan internet, ukur kecepatan unduh, ukur kecepatan unggah";
const OG_URL = "https://do-calculate.com/calculator/id/internet-speed";
function InternetSpeed() {
  const [speed, setSpeed] = useState(null);
  const measureSpeed = async () => {
    const fileSizeInBytes = 5000000;
    const start = new Date().getTime();
    const response = await fetch(
      "https://eu.httpbin.org/stream-bytes/5000000",
      {
        method: "GET",
        headers: {
          "Cache-Control": "no-cache",
        },
      }
    );
    if (response.ok) {
      const end = new Date().getTime();
      const duration = (end - start) / 1000;
      const bitsLoaded = fileSizeInBytes * 8;
      const speedBps = (bitsLoaded / duration).toFixed(2);
      const speedKbps = (speedBps / 1024).toFixed(2);
      const speedMbps = (speedKbps / 1024).toFixed(2);
      setSpeed(`${speedMbps} Mbps`);
    } else {
      alert("Silakan coba lagi nanti");
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <h2 style={{ fontSize: "14px" }}>Alat Pengukur Kecepatan Internet</h2>
                <p>
                  Alat pengukur kecepatan internet membantu Anda mengetahui kecepatan koneksi internet Anda
                  dengan akurat. Alat ini mengukur kecepatan unduh dan unggah, membantu Anda memastikan
                  bahwa Anda mendapatkan kecepatan yang Anda bayarkan kepada penyedia layanan.
                </p>
                <h3 style={{ fontSize: "14px" }}>Cara Menggunakan Alat</h3>
                <p>
                  Untuk menggunakan alat ini, tekan tombol "Ukur Kecepatan Internet" dan tunggu hingga
                  proses selesai. Hasil akan ditampilkan dalam megabit per detik (Mbps). Pastikan Anda
                  tidak mengunduh atau mengunggah file besar selama pengukuran untuk mendapatkan hasil yang akurat.
                </p>
                <hr />
              </div>
              <br />
            </div>
             <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div
                  className="form-group align-items-center"
                  style={{ justifyContent: "center" }}
                >
                  <Button
                    variant="contained"
                    color="success"
                    onClick={measureSpeed}
                    sx={{
                      fontSize: {
                        md: "17px",
                      },
                    }}
                  >
                   Ukur Kecepatan Internet
                  </Button>
                  <div>
                    <br />
                  </div>
                  { speed && (
                    <>
                      <div>
                        <span>Kecepatan internet Anda: </span>
                        <b className="alert alert-success">{speed}</b>
                      </div>
                      <br />
                    </>
                  )}
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                Informasi Tentang Pengukuran Kecepatan Internet
              </div>
              <div className="info-section-body">
                <h4>Faktor yang Mempengaruhi Kecepatan Internet</h4>
                <p>
                  Pengukuran kecepatan internet tergantung pada beberapa faktor, termasuk jenis koneksi
                  internet (seperti ADSL, fiber optik, 4G), perangkat yang digunakan, dan jumlah perangkat
                  yang terhubung ke jaringan pada saat yang sama. Penting untuk melakukan beberapa pengukuran
                  pada waktu yang berbeda untuk mendapatkan gambaran akurat tentang kinerja koneksi Anda.
                </p>
                <h4>Bagaimana Alat Mengukur Kecepatan</h4>
                <p>
                  Alat ini menggunakan file uji untuk mengukur waktu yang dibutuhkan untuk mengunduh atau
                  mengunggahnya, kemudian menghitung kecepatan internet berdasarkan itu. Pastikan Anda tidak
                  mengunduh atau mengunggah file besar lainnya selama pengukuran untuk mendapatkan hasil yang akurat.
                </p>
                <h4>Tips Mendapatkan Hasil Terbaik</h4>
                <ul>
                  <li>
                    Ukur kecepatan pada waktu yang berbeda dalam sehari untuk mendapatkan rata-rata yang akurat.
                  </li>
                  <li>
                    Pastikan perangkat lain tidak menggunakan internet selama pengukuran.
                  </li>
                  <li>
                    Restart router Anda sebelum pengukuran untuk mendapatkan kinerja terbaik.
                  </li>
                </ul>
                <hr />
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default InternetSpeed;